import React, { useContext, useEffect, useState } from 'react'
import { Button, Card, Col, Container, Form, InputGroup, Row, Spinner, Table } from 'react-bootstrap'
import { useMediaQuery } from 'react-responsive';
import { useLocation, useNavigate } from 'react-router-dom';
import { FaWindowClose } from 'react-icons/fa';
import Swal from 'sweetalert2';
import { ModalTambahPcpDetail } from '../../../components/Modal';
import { AuthContext, ThemeContext } from '../../../auth';
import { HeaderWeb, SidebarComponent } from '../../../components';
import { axiosAuth } from '../../../api';


function PcpPenjualan() {

    const { theme } = useContext(ThemeContext);
    const location = useLocation();
    const { data } = location.state || {};
    const { showSidebar, accessToken, userInfo } = useContext(AuthContext);
    const isMobile = useMediaQuery({ maxWidth: 1024 });
    const [listCategory, setListCategory] = useState([]);
    const [projectName, setProjectName] = useState('');
    const [wapu, setWapu] = useState(false);
    const [description, setDescription] = useState('');
    const [franco, setFranco] = useState('Jakarta');
    const [disabled, setDisabled] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const retrieveCategoryProduct = () => {
        axiosAuth.get(`/api/pcp/categories`,
            {
                headers:
                {
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json',
                    withCredentials: true,
                    Authorization: `Bearer ${accessToken}`,
                },

            })
            .then(res => {

                // setListCategory(res.data.data);

                const filteredData = res.data.data.filter((category) => category?.categoryName != 'Solusi');

                setListCategory(filteredData);

            }).catch(err => {
                console.error(err);
            })
    };

    useEffect(() => {
        if (accessToken !== undefined && pcpData !== undefined) retrieveCategoryProduct();
    }, [accessToken]);

    const [pcpData, setPcpData] = useState([]);

    const [showAddPcpDetail, setShowAddPcpDetail] = useState(false);

    const handleShowPcpDetail = () => {
        setShowAddPcpDetail(true)
    };

    const numberFormat = (value) =>
        new Intl.NumberFormat('IN-ID', {
            style: 'currency',
            currency: 'IDR'
        }).format(value);


    const handleDeletePcpLocal = async (index) => {
        const result = await Swal.fire({
            title: 'Apakah anda yakin ingin menghapus produk ini?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Ya, hapus produk ini!',
            cancelButtonText: 'Batalkan',
        });

        if (result.isConfirmed) {

            const updatedPcpData = pcpData.filter((_, i) => i !== index);
            setPcpData(updatedPcpData);

        } else {
            <></>
        }

    };

    const [ppnPercentage, setPpnPercentage] = useState(11);

    const totalHargaJual = pcpData.reduce((total, item) => total + (item.subtotal || 0), 0);

    const ppnAmount = totalHargaJual * (ppnPercentage / 100);

    const grandTotalRaw = totalHargaJual + ppnAmount;

    // Pembulatan grandTotal
    const remainder = grandTotalRaw % 100;
    const grandTotal = remainder >= 50
        ? Math.round(grandTotalRaw + (100 - remainder))
        : Math.round(grandTotalRaw - remainder);

    const overHead = totalHargaJual * 0.03;

    const [edlCost, setEdlCost] = useState(0);
    const [delivCost, setDeliveryCost] = useState(0);
    const [financialCost, setFinancialCost] = useState(0);
    const [otherFinancialCost, setOtherFinancialCost] = useState(0);
    const [otherAllowance, setOtherAllowance] = useState(0);

    function handleChangeEdl(e) {
        const inputValue = e.target.value;
        const numericValue = parseFloat(inputValue.replace(/[^\d]/g, '')) || 0;

        setEdlCost(numericValue);
    };

    function handleChangeDelivery(e) {
        const inputValue = e.target.value;
        const numericValue = parseFloat(inputValue.replace(/[^\d]/g, '')) || 0;

        setDeliveryCost(numericValue);
    };

    function handleChangeFinancial(e) {
        const inputValue = e.target.value;
        const numericValue = parseFloat(inputValue.replace(/[^\d]/g, '')) || 0;

        setFinancialCost(numericValue);
    };

    function handleChangeOtherFinancial(e) {
        const inputValue = e.target.value;
        const numericValue = parseFloat(inputValue.replace(/[^\d]/g, '')) || 0;

        setOtherFinancialCost(numericValue);
    };

    function handleChangeOtherAllowance(e) {
        const inputValue = e.target.value;
        const numericValue = parseFloat(inputValue.replace(/[^\d]/g, '')) || 0;

        setOtherAllowance(numericValue);
    };

    const navigate = useNavigate();

    const handleBack = () => {
        navigate(-1)
    }

    const subTotalCost = (overHead) + (edlCost || 0) + (delivCost || 0) + (financialCost || 0) + (otherFinancialCost || 0) + (otherAllowance || 0);

    const totalHargaBeli = pcpData.reduce((total, item) => total + item.purchaseCalculate, 0);

    const calculateSubTotalSelling = pcpData.reduce((total, item) => total + item.subtotal, 0);

    const handleQtyChange = (index, newQty) => {
        const updatedPcpData = pcpData.map((item, i) => {
            if (i === index) {
                const updatedSubTotal = item.sellingPrice * newQty;
                const updatedSubTotalBuying = item.buyingPrice * newQty;
                return { ...item, quantity: newQty, subtotal: updatedSubTotal, purchaseCalculate: updatedSubTotalBuying };
            }
            return item;
        });
        setPcpData(updatedPcpData);
    };

    const calculateSubTotalBuying = pcpData.reduce((total, item) => total + item.purchaseCalculate, 0);

    const grossMargin = parseFloat(calculateSubTotalSelling) - parseFloat(calculateSubTotalBuying) || 0;

    const nettMargin = parseFloat(grossMargin) - parseFloat(subTotalCost) || 0;

    const nettPercentage = parseInt(nettMargin) / parseInt(totalHargaJual) * 100 || 0;

    const formStyles = {
        label: {
            fontFamily: 'Poppins-Medium',
            color: theme === 'light' ? '#FFFFFF' : '#222222',
        },
        input: {
            color: theme === 'light' ? '#FFFFFF' : '#222222',
            fontFamily: 'Poppins-Regular',
            minHeight: '50px',
            borderColor: '#ced4da',
            background: theme === 'light' ? '#212529' : '#FFFFFF',
        },
        inputQty: {
            color: theme === 'light' ? '#FFFFFF' : '#222222',
            fontFamily: 'Poppins-Regular',
            maxWidth: '90px',
            borderColor: '#ced4da',
            background: theme === 'light' ? '#212529' : '#FFFFFF',
        },
        inputBodyGroup: {
            color: theme === 'light' ? '#FFFFFF' : '#222222',
            fontFamily: 'Poppins-Regular',
            maxWidth: '90px',
            maxHeight: '50px',
            borderColor: '#ced4da',
            background: theme === 'light' ? '#212529' : '#FFFFFF',
        },
        inputNettmargin: {
            color: nettMargin <= 300000
                ? 'red'
                : theme === 'light'
                    ? '#FFFFFF'
                    : '#222222',
            fontFamily: 'Poppins-Regular',
            minHeight: '50px',
            borderColor: '#ced4da',
            background: theme === 'light' ? '#212529' : '#FFFFFF',
        },
    };

    const selectStyles = {
        control: (cityided, state) => ({
            ...cityided,
            minHeight: '50px',
            border: state.isFocused ? '1px solid #80bdff' : '1px solid #ced4da',
            boxShadow: state.isFocused ? '0 0 0 0.3rem rgba(0, 123, 255, 0.25)' : null,
            '&:hover': {
                borderColor: '#80bdff',
            },
            textAlign: 'left',
            fontFamily: 'Poppins-Regular',
            background: theme === 'light' ? '#212529' : '#FFFFFF',
        }),
        option: (provided, state) => ({
            ...provided,
            color: state.isSelected ? '#fff' : '#333',
            background: state.isSelected ? '#007bff' : state.isFocused ? '#f5f5f5' : '#fff',
            fontFamily: 'Poppins-Regular',
        }),
        singleValue: (provided) => ({
            ...provided,
            color: theme === 'light' ? '#FFFFFF' : '#222',
            fontFamily: 'Poppins-Regular',
        }),
        input: (provided) => ({
            ...provided,
            color: theme === 'light' ? '#FFFFFF' : '#222',
            fontFamily: 'Poppins-Regular',
        }),
    };

    const handleSubmitPCP = async (event) => {

        event.preventDefault();

        const result = await Swal.fire({
            title: 'Ajukan PCP?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Ajukan',
            cancelButtonText: 'Batal',
        });

        if (result.isConfirmed) {

            setDisabled(true);
            setIsSubmitting(true);

            const checkingMargin = pcpData.filter(item => item.validateMargin === false);

            const dataPCP = {
                username: userInfo?.username,
                projectName: projectName,
                status: checkingMargin.length !== 0 || nettMargin <= 300000 ? 'pending' : !description ? 'approved' : 'pending',
                leadId: data?.id,
                description: description,
                isWapu: wapu,
                franco: franco,
                salesTotal: totalHargaJual,
                purchasesTotal: totalHargaBeli,
                overhead: overHead,
                externalDirectLabor: edlCost,
                deliveryCost: delivCost,
                financialCost: financialCost,
                otherFinancialCost: otherFinancialCost,
                otherAllowance: otherAllowance,
                ppnPercentage: parseInt(ppnPercentage),
                ppn: ppnAmount,
                grandTotal: grandTotal,
                details: pcpData
            };

            try {

                const response = await axiosAuth.post(`/api/pcp`, dataPCP, {
                    headers: {
                        'Access-Control-Allow-Origin': '*',
                        'Content-Type': 'application/json',
                        withCredentials: true,
                        Authorization: `Bearer ${accessToken}`,
                    },
                });

                handleBack();

                Swal.fire({
                    icon: 'success',
                    title: 'Berhasil mengajukan PCP',
                    showConfirmButton: true,
                });

                setIsSubmitting(false);
                setDisabled(false);

            } catch (err) {
                console.error(err);

                Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: 'Terjadi kesalahan saat pengajuan PCP',
                });

                setIsSubmitting(false);
                setDisabled(false);

            } finally {

                setIsSubmitting(false);
                setDisabled(false);

            }

        } else {
            <></>
        }
    };


    return (
        <div style={{
            overflowX: 'hidden',
            maxWidth: '100vw',
            backgroundColor: theme === 'light' ? '#121212' : '#FFFFFF',
            transition: '0.8s'
        }}>
            <SidebarComponent />
            <div id={theme === 'light' ? 'containerAppDark' : 'containerAppLight'}
                style={{
                    width: isMobile ? '100%' : `calc(100% - ${showSidebar ? '78px' : '190px'})`,
                    marginLeft: isMobile ? '0px' : showSidebar ? '78px' : '190px',
                    transition: '0.8s'
                }}
            >
                <div className={isMobile ? 'ms-2' : 'ms-3 me-2'}>
                    <Row>
                        <Col xs={6} lg={6} className='text-start'>
                            <h3 className='pt-4' style={{ fontFamily: 'Poppins-Medium', fontSize: isMobile ? '25px' : '38px', color: theme === 'light' ? '#FFFFFF' : '', marginBottom: '0px' }}>
                                PCP Penjualan
                            </h3>
                        </Col>
                        <Col xs={6} lg={6} className={isMobile === false ? 'text-end my-auto' : 'text-end my-auto pt-4'}>
                            <HeaderWeb />
                        </Col>
                    </Row>
                </div>
                <Form >
                    <div className={isMobile ? 'ms-1 mt-4' : 'ms-3 mt-4'}>
                        <Row>
                            <Col xs={12} lg={4} className="mb-3">
                                <Form.Label style={formStyles.label} htmlFor='customer'>Customer</Form.Label>
                                <Form.Control
                                    id='customer'
                                    type="text"
                                    defaultValue={
                                        data?.customer?.title?.titleName === "Others"
                                            ? data?.customer?.name
                                            : `${data?.customer?.title?.titleName}. ${data?.customer?.name}`
                                    }
                                    readOnly
                                    disabled={disabled || pcpData.length !== 0}
                                    style={formStyles.input}
                                />
                            </Col>
                            <Col xs={12} lg={4} className="mb-3">
                                <Form.Label style={formStyles.label} htmlFor='project'>Nama Projek*</Form.Label>
                                <Form.Control
                                    id='project'
                                    type="text"
                                    onChange={(e) => setProjectName(e.target.value)}
                                    value={projectName}
                                    required
                                    disabled={disabled || pcpData.length !== 0}
                                    style={formStyles.input}
                                />
                            </Col>
                            <Col xs={12} lg={3} className="mb-3">
                                <Form.Label style={formStyles.label} htmlFor='top'>Term of Payment*</Form.Label>
                                <InputGroup >
                                    <Form.Control
                                        id="top"
                                        type="text"
                                        defaultValue={data?.customer?.top || ''}
                                        readOnly
                                        placeholder="Term of Payment"
                                        style={formStyles.input}
                                    />
                                    <InputGroup.Text
                                        style={formStyles.input}
                                        id="basic-addon1"
                                    >
                                        Hari
                                    </InputGroup.Text>
                                </InputGroup>
                            </Col>
                            <Col xs={12} lg={1} className="mb-3">
                                <Form.Label style={formStyles.label}>Wapu</Form.Label>
                                <Form.Check
                                    type='checkbox'
                                    id='default-checkbox'
                                    onChange={(e) => setWapu(e.target.checked)}
                                    value={wapu}
                                    style={formStyles.label}
                                    disabled={disabled || pcpData.length !== 0}
                                />
                            </Col>
                            <Col xs={12} lg={4} className="mb-3">
                                <Form.Label style={formStyles.label}>Franco*</Form.Label>
                                <Form.Control
                                    id='franco'
                                    type="text"
                                    onChange={(e) => setFranco(e.target.value)}
                                    value={franco}
                                    required
                                    disabled={disabled || pcpData.length !== 0}
                                    style={formStyles.input}
                                />
                            </Col>
                            <Col xs={12} lg={5} className="mb-3">

                                <Form.Label style={formStyles.label} htmlFor='description'>Syarat dan ketentuan tambahan</Form.Label>
                                <Form.Control
                                    id="description"
                                    as="textarea"
                                    rows={3}
                                    onChange={(e) => setDescription(e.target.value)}
                                    value={description}
                                    disabled={disabled || pcpData.length !== 0}
                                    placeholder="Syarat dan ketentuan tambahan"
                                    style={formStyles.input}
                                />

                            </Col>
                        </Row>
                    </div>

                    <div className={isMobile ? 'ms-1 mt-4' : 'ms-3 mt-4 me-3'} >
                        <h3 className='text-center' style={{ fontFamily: 'Poppins-Medium', color: theme === 'light' ? '#FFFFFF' : '#222', fontSize: isMobile ? '25px' : '38px' }}>
                            PCP Detail
                        </h3>
                        <div>
                            <Row>
                                <Col xs={12} lg={6} className='text-start'>
                                    <Button
                                        variant='btn'
                                        id={theme === 'light' ? 'actionButtonModalDark' : 'actionButtonModalLight'}
                                        disabled={
                                            !data ||
                                            !projectName ||
                                            !franco
                                        }
                                        onClick={handleShowPcpDetail}
                                    >
                                        Tambah
                                    </Button>
                                </Col>
                            </Row>
                        </div>
                        <Table className='mt-4' bordered responsive data-bs-theme={theme === "light" ? "dark" : "light"}>
                            <thead>
                                <tr style={{ fontFamily: 'Poppins-Regular', textAlign: 'center' }}>
                                    <th
                                        style={{
                                            textAlign: 'left'
                                        }}
                                    >
                                        Nama Produk
                                    </th>
                                    <th>Jenis Produk</th>
                                    <th
                                        style={{
                                            textAlign: 'right'
                                        }}
                                    >
                                        Harga Beli
                                    </th>
                                    <th
                                        style={{
                                            textAlign: 'right'
                                        }}
                                    >
                                        Harga Jual
                                    </th>
                                    <th>Qty</th>
                                    <th
                                        style={{
                                            textAlign: 'right'
                                        }}
                                    >
                                        Sub Total
                                    </th>
                                    <th
                                        style={{
                                            textAlign: 'center'
                                        }}
                                    >
                                        %
                                    </th>
                                    <th>Hapus</th>
                                </tr>
                            </thead>
                            <tbody>
                                {pcpData.map((item, index) => (
                                    <tr key={index} style={{ fontFamily: 'Poppins-Light', textAlign: 'center' }}>
                                        <td style={{
                                            textAlign: 'left',
                                            width: '350px'
                                        }}>
                                            {item.productName}
                                        </td>
                                        <td>
                                            {item.categoryName}
                                        </td>
                                        <td style={{
                                            textAlign: 'right'
                                        }}>
                                            {numberFormat(item.buyingPrice)}
                                        </td>
                                        <td
                                            style={{
                                                textAlign: 'right'
                                            }}
                                        >
                                            {numberFormat(item.sellingPrice)}
                                        </td>
                                        <td >
                                            {item.quantity}
                                        </td>
                                        <td
                                            style={{
                                                textAlign: 'right'
                                            }}
                                        >
                                            {numberFormat(item.subtotal)}
                                        </td>
                                        <td
                                            style={{
                                                textAlign: 'center'
                                            }}
                                        >
                                            <span style={{
                                                color: item.validateMargin === true ? '#16C47F' : '#FF0060'
                                            }}>
                                                {item.margin ? `${item.margin}%` : '0%'}
                                            </span>
                                        </td>
                                        <td>
                                            <div>
                                                <Button
                                                    variant='btn'
                                                    onClick={() => handleDeletePcpLocal(index)}
                                                    style={{
                                                        border: 'none',
                                                        backgroundColor: 'transparent',
                                                    }}
                                                >
                                                    &nbsp;<FaWindowClose size={20} color='#FF0060' />&nbsp;
                                                </Button>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                        {pcpData.length === 0 ?

                            (
                                <>

                                </>
                            )
                            :
                            (
                                <div className='mt-5'>
                                    <Row>
                                        <Col xs={12} lg={4} className={isMobile ? 'mb-5 text-start' : 'text-start'}>
                                            <Card
                                                data-bs-theme={theme === 'light' ? 'dark' : ''}>
                                                <Card.Body>
                                                    <div>
                                                        <Form.Label style={formStyles.label} htmlFor='totalSelling'>Total Harga Jual</Form.Label>
                                                        <Form.Control
                                                            id='totalSelling'
                                                            type='text'
                                                            className='mb-3'
                                                            value={numberFormat(totalHargaJual) || ''}
                                                            readOnly
                                                            style={formStyles.input}
                                                        />
                                                        <Form.Label style={formStyles.label} htmlFor='ppn'>PPN%</Form.Label>
                                                        <Form.Control
                                                            id='ppn'
                                                            type='text'
                                                            className='mb-3'
                                                            value={ppnPercentage}
                                                            onChange={(e) => {
                                                                const value = e.target.value;
                                                                if (/^\d*$/.test(value)) {
                                                                    setPpnPercentage(value);
                                                                }
                                                            }}
                                                            required
                                                            style={formStyles.input}
                                                        />
                                                        <Form.Label style={formStyles.label} htmlFor='ppnValue'>PPN Amount</Form.Label>
                                                        <Form.Control
                                                            id='ppnValue'
                                                            type='text'
                                                            className='mb-3'
                                                            value={numberFormat(ppnAmount)}
                                                            readOnly
                                                            style={formStyles.input}
                                                        />
                                                        <Form.Label style={formStyles.label} htmlFor='grandTotal'>Grand Total</Form.Label>
                                                        <Form.Control
                                                            id='grandTotal'
                                                            type='text'
                                                            className='mb-3'
                                                            value={numberFormat(grandTotal)}
                                                            readOnly
                                                            style={formStyles.input}
                                                        />
                                                    </div>
                                                </Card.Body>
                                            </Card>
                                        </Col>
                                        <Col xs={12} lg={2} ></Col>
                                        <Col xs={12} lg={6} >
                                            <Card
                                                data-bs-theme={theme === 'light' ? 'dark' : ''}
                                            >
                                                <Card.Body>
                                                    <div>
                                                        <Row>
                                                            <Col xs={12} lg={6}>
                                                                <Form.Label style={formStyles.label} htmlFor='overHead'>Over Head (3%)</Form.Label>
                                                                <Form.Control
                                                                    id='overHead'
                                                                    type='text'
                                                                    className='mb-3'
                                                                    value={numberFormat(overHead) || 0}
                                                                    readOnly
                                                                    style={formStyles.input}
                                                                />
                                                            </Col>
                                                            <Col xs={12} lg={6}>
                                                                <Form.Label style={formStyles.label} htmlFor='edlCost'>External Direct Labor Cost</Form.Label>
                                                                <Form.Control
                                                                    id='edlCost'
                                                                    type='text'
                                                                    className='mb-3'
                                                                    onChange={handleChangeEdl}
                                                                    value={`Rp ${edlCost ? edlCost.toLocaleString('id-ID') : '0,00'}`}
                                                                    required
                                                                    style={formStyles.input}
                                                                />
                                                            </Col>
                                                            <Col xs={12} lg={6}>
                                                                <Form.Label style={formStyles.label} htmlFor='financeCost'>Financial Cost</Form.Label>
                                                                <Form.Control
                                                                    id='financeCost'
                                                                    type='text'
                                                                    className='mb-3'
                                                                    onChange={handleChangeFinancial}
                                                                    value={`Rp ${financialCost ? financialCost.toLocaleString('id-ID') : '0,00'}`}
                                                                    required
                                                                    style={formStyles.input}
                                                                />
                                                            </Col>
                                                            <Col xs={12} lg={6}>
                                                                <Form.Label style={formStyles.label} htmlFor='otherFinanceCost'>Other Financial Cost</Form.Label>
                                                                <Form.Control
                                                                    id='otherFinanceCost'
                                                                    type='text'
                                                                    className='mb-3'
                                                                    onChange={handleChangeOtherFinancial}
                                                                    value={`Rp ${otherFinancialCost ? otherFinancialCost.toLocaleString('id-ID') : '0,00'}`}
                                                                    required
                                                                    style={formStyles.input}
                                                                />
                                                            </Col>
                                                            <Col xs={12} lg={6}>
                                                                <Form.Label style={formStyles.label} htmlFor='delivCost'>Delivery Cost</Form.Label>
                                                                <Form.Control
                                                                    id='delivCost'
                                                                    type='text'
                                                                    className='mb-3'
                                                                    onChange={handleChangeDelivery}
                                                                    value={`Rp ${delivCost ? delivCost.toLocaleString('id-ID') : '0,00'}`}
                                                                    required
                                                                    style={formStyles.input}
                                                                />
                                                            </Col>
                                                            <Col xs={12} lg={6}>
                                                                <Form.Label style={formStyles.label} htmlFor='otherAllow'>Other Allowance</Form.Label>
                                                                <Form.Control
                                                                    id='otherAllow'
                                                                    type='text'
                                                                    className='mb-3'
                                                                    onChange={handleChangeOtherAllowance}
                                                                    value={`Rp ${otherAllowance ? otherAllowance.toLocaleString('id-ID') : '0,00'}`}
                                                                    required
                                                                    style={formStyles.input}
                                                                />
                                                            </Col>
                                                            <Col xs={12} lg={6}>
                                                                <Form.Label style={formStyles.label} htmlFor='subTotalCost'>Sub Total Cost</Form.Label>
                                                                <Form.Control
                                                                    id='subTotalCost'
                                                                    type='text'
                                                                    className='mb-3'
                                                                    value={numberFormat(subTotalCost) || '0,00'}
                                                                    readOnly
                                                                    style={formStyles.input}
                                                                />
                                                            </Col>
                                                            <Col xs={12} lg={6}>
                                                                <Form.Label style={formStyles.label} htmlFor='nettMargin'>Nett Margin</Form.Label>
                                                                <InputGroup className="mb-3">
                                                                    <Form.Control
                                                                        id='nettMargin'
                                                                        type='text'
                                                                        className='mb-3'
                                                                        value={numberFormat(nettMargin) || '0,00'}
                                                                        readOnly
                                                                        style={formStyles.inputNettmargin}
                                                                    />
                                                                    <InputGroup.Text
                                                                        id="basic-addon1"
                                                                        style={formStyles.inputBodyGroup}
                                                                    >
                                                                        {nettPercentage.toFixed(2) + '%'}
                                                                    </InputGroup.Text>
                                                                </InputGroup>
                                                            </Col>
                                                        </Row>
                                                    </div>
                                                </Card.Body>
                                            </Card>
                                            <div className='text-end mt-4 mb-3'>
                                                {isSubmitting ? (
                                                    <Button
                                                        id={theme === 'light' ? 'actionButtonModalDark' : 'actionButtonModalLight'}
                                                        variant='btn'
                                                        disabled
                                                        style={{ minWidth: '90px' }}
                                                    >
                                                        <Spinner
                                                            animation="border"
                                                            size='sm'
                                                        />
                                                    </Button>
                                                ) : (
                                                    <Button
                                                        variant='btn'
                                                        id={theme === 'light' ? 'actionButtonModalDark' : 'actionButtonModalLight'}
                                                        onClick={handleSubmitPCP}
                                                        disabled={disabled ||
                                                            pcpData == 0
                                                        }
                                                    >
                                                        Simpan
                                                    </Button>
                                                )}
                                                <Button
                                                    variant='secondary'
                                                    className='ms-3'
                                                    onClick={handleBack}
                                                    style={{ fontFamily: 'Poppins-Regular', minHeight: '45px' }}
                                                >
                                                    Kembali
                                                </Button>
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                            )
                        }
                        <br />
                        <br />
                        <br />
                    </div>
                </Form>
            </div>
            <ModalTambahPcpDetail
                showAddPcpDetail={showAddPcpDetail}
                setShowAddPcpDetail={setShowAddPcpDetail}
                listCategory={listCategory}
                formStyles={formStyles}
                selectStyles={selectStyles}
                wapu={wapu}
                onSave={(newData) => setPcpData((prev) => [...prev, newData])}
            />
        </div >
    )
}

export default PcpPenjualan
